import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import TaskDetailDrawer from '../TaskDetailDrawer';
import TaskThreads from '../TaskThreads';

// Mirrors isManagement in App.js: who /edit-task/:id lets in.
const CAN_EDIT_TASKS = ['HR', 'ADMIN', 'MANAGER', 'ACCOUNTS', 'TEAM LEAD'];

/**
 * The task drawer as the chat opens it - from an approval card in the thread
 * or a card in the Tasks panel. Its own component so the router hook is only
 * reached once a task is actually open; ChatWindow is also rendered outside
 * a router (its tests) and has no other use for one.
 *
 * The task's discussion sits under the details, so a task update in the chat
 * can be answered without leaving it; reading it here clears its unread badge.
 * `focusDiscussion` scrolls straight to it - what "Open discussion" asks for.
 */
const ChatTaskDrawer = ({ taskId, myRole, canDecide = false, onDecided, onClose, focusDiscussion = false }) => {
    const navigate = useNavigate();
    const scrolled = useRef(false);
    const toDiscussion = (el) => {
        if (!el || !focusDiscussion || scrolled.current) return;
        scrolled.current = true;
        setTimeout(() => el.scrollIntoView({ block: 'start', behavior: 'smooth' }), 80);
    };
    return (
        <TaskDetailDrawer
            taskId={taskId}
            onClose={onClose}
            onEdit={CAN_EDIT_TASKS.includes(myRole) ? () => navigate(`/edit-task/${taskId}`) : undefined}
            onOpenFull={() => navigate(`/task/${taskId}`)}
            canDecide={canDecide}
            onDecided={onDecided}
            renderExtra={(task) => (
                <div className="tdd-section tdd-discussion" ref={toDiscussion}>
                    <TaskThreads task={task} />
                </div>
            )}
        />
    );
};

export default ChatTaskDrawer;
